import { For } from '../c-mp/comp/For'
import { Icon } from '../c-mp/comp/Icon'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { mutateState, useState } from '../c-mp/fun/useState'
import { andrisEmail } from '../fun/andrisEmail'
import { getAge } from '../fun/getAge'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { isDead } from '../fun/isDead'
import { setPageTitle } from '../fun/setPageTitle'
import { ICON_PLUS } from '../icon/ICON_PLUS'
import { ICON_RADIO_OFF } from '../icon/ICON_RADIO_OFF'
import { ICON_RADIO_ON } from '../icon/ICON_RADIO_ON'
import { _ } from '../model/ccc'
import { PERSON_DETAILS } from '../model/PERSON_DETAILS'
import { Relationship } from '../model/Relationship'
import { PersonLinkComp } from './PersonLinkComp'

export const PageRelativesAliveComp = defineComponent<{}>(
	'PageRelativesAliveComp',
	(props, $) => {
		setPageTitle('Élő rokonok')

		const data = getDataOrThrow()

		const state = useState('state', { close: true })

		return (
			<div class={_.ccc_page}>
				<h1>
					Élő <b>rokonok</b>
				</h1>
				<div class={_.ccc_tiles__centered__compact}>
					<button
						class={() => [
							_.ccc_button__rounded,
							state.close && _.ccc__selected,
						]}
						onclick={() => {
							mutateState($.debugName, 'set close [tbc3xu]', () => {
								state.close = true
							})
						}}
					>
						<Slot
							isTrustedHtml
							get={() => (state.close ? ICON_RADIO_ON : ICON_RADIO_OFF)}
						/>{' '}
						A legközelebbi rokonok
					</button>
					<button
						class={() => [
							_.ccc_button__rounded,
							!state.close && _.ccc__selected,
						]}
						onclick={() => {
							mutateState($.debugName, 'set not close [tbc3zg]', () => {
								state.close = false
							})
						}}
					>
						<Slot
							isTrustedHtml
							get={() => (state.close ? ICON_RADIO_OFF : ICON_RADIO_ON)}
						/>{' '}
						Távolabbi rokonok
					</button>
				</div>
				<div class={_.ccc_tiles__centered}>
					<For
						debugName='Élő rokonok'
						each={() =>
							Object.values(data.personsById).filter(
								(it) =>
									it.relationship !== Relationship.Parditka &&
									(state.close
										? it.relationship !== Relationship.Related
										: it.relationship === Relationship.Related) &&
									!isDead(data, it) &&
									getAge(it.birthDate) != null,
							)
						}
						render={PersonLinkComp}
					/>
					<a
						class={_.ccc_button__plus}
						href={andrisEmail(
							'Új rokon',
							`És hiányoltam valakit:\n\n${PERSON_DETAILS}`,
						)}
						title='Új rokon'
					>
						<Icon svg={ICON_PLUS} /> rokon
					</a>
				</div>
			</div>
		)
	},
)
